import React from 'react'
import Subheader from '../../component/Subheader'
import HaldiHead from '../Haldi/HaldiHead';
import HaldiBook from '../Haldi/HaldiBook';
import HaldiGallery from '../Haldi/HaldiGallery';
import HaldiCraft from '../Haldi/HaldiCraft';
import HaldiInstagram from '../Haldi/HaldiInstagram';
import WeddingTradition from './WeddingTradition';
import WeddingTab from './WeddingTab';
import WeddingEmotion from './WeddingEmotion';

export default function Wedding() {
    const subheadData = {
      image: '../image/wedding-banner.webp',
      heading: 'Wedding Story With Couture Made Just for You',
      pagename: 'Wedding',
    }


    const headdata = {
        title: "Crafting Weddings That Tell Your Love Story",
        heading: "Moments That Last a Lifetime",
        description:"Your wedding day deserves bridalwear that feels deeply personal and timeless. At Sonam Label, we design ensembles that celebrate your unique story through refined silhouettes, intricate hand-embellished details, and couture-level finishing. Each piece is thoughtfully created to honour tradition while embracing modern elegance, ensuring you feel radiant, confident, and beautifully yourself as you step into one of life’s most cherished moments.",
        buttonText: "Learn More",
        link: "/contact",
    };


    const haldigallery = [
        { src: "../image/weddinggallery-1.webp"},
        { src: "../image/weddinggallery-2.webp"},
        { src: "../image/weddinggallery-3.webp"},
        { src: "../image/weddinggallery-4.webp"},
        { src: "../image/weddinggallery-5.webp"},
    ];


    const haldiCraft = {
      heading: "Luxury Bridalwear for Every Bride",
      description:"At Sonam Label, every bride is invited into a world where meticulous craftsmanship meets contemporary elegance. Each gown is made from luxurious fabrics, featuring graceful drapes and exquisite detailing designed for comfort, confidence, and effortless beauty. Whether walking down the aisle or celebrating with loved ones, our bridalwear enhances your natural radiance and ensures every moment feels extraordinary and unforgettable."
    };


    const haldiInsta = [
      {image: "/image/weddinginsta-1.webp"},
      {image: "/image/weddinginsta-2.webp"},
      {image: "/image/weddinginsta-3.webp"},
      {image: "/image/weddinginsta-4.webp"},
      {image: "/image/weddinginsta-5.webp"},
    ];

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <HaldiHead headdata={headdata}/>
    <WeddingTradition/>
    <WeddingTab/>
    <WeddingEmotion/>
    <HaldiBook/>
    <HaldiGallery haldigallery={haldigallery}/>
    <HaldiCraft haldiCraft={haldiCraft}/>
    <HaldiInstagram haldiInsta={haldiInsta}/>
    </>
  )
}